import React from 'react'
import {
  Input,
  VALIDATION_TYPES,
  ColorPicker,
  Upload,
} from 'components/Form'
import { getMessage } from 'lib/translator'
import './style.scss'



function CampaignConfigInputs({
	generateStateMappers,
	values
}) {
	const acceptedImgType = "image/jpeg,image/jpg,image/png,image/gif"
	return (
		<>
			<div className="two-col-grid">
				<Input
					type="text"
					placeholder="Enter Title"
					className="voucher-center-title"
					label={`${getMessage('offer.campaigns.config.title')} (limit: 14 char) ${values.title.length} char`}
					required
					{...generateStateMappers({
						stateKeys: ['title'],
						loseEmphasisOnFill: true,
						validationType: VALIDATION_TYPES.ONSUBMIT,
					})}
				/>
				<Input
					type="text"
					placeholder="Enter Description"
					className="voucher-center-description"
					label={`${getMessage('offer.campaigns.config.description')} (limit: 28 char) ${values.description.length} char`}
          required
					{...generateStateMappers({
						stateKeys: ['description'],
						loseEmphasisOnFill: true,
						validationType: VALIDATION_TYPES.ONSUBMIT,
					})}
				/>
			</div>

			<div className='consolidated-inputs-section'>
				<div className='section-title'>
					Color Pickers
				</div>
				<div className='three-col-grid section-body'>
					<ColorPicker
						className="background-color-picker"
						label={getMessage('offer.campaigns.config.backgroundColor')}
						required
						{...generateStateMappers({
							stateKeys: ['backgroundColor'],
							loseEmphasisOnFill: true,
						})}
					/>
					<ColorPicker
						className="background-gradient-colorA-picker"
						label={getMessage('offer.campaigns.config.backgroundGradientColorA')}
						required
						{...generateStateMappers({
							stateKeys: ['backgroundGradientColorA'],
							loseEmphasisOnFill: true,
						})}
					/>
					<ColorPicker
						className="background-gradient-colorB-picker"
						label={getMessage('offer.campaigns.config.backgroundGradientColorB')}
						required
						{...generateStateMappers({
							stateKeys: ['backgroundGradientColorB'],
							loseEmphasisOnFill: true,
						})}
					/>
				</div>
			</div>

			<div className='consolidated-inputs-section'>
				<div className='section-title'>
					CTA
				</div>
				<div className='section-body'>
					<div className="two-col-grid">
						<Input
							type="text"
							placeholder="Enter CTA Button Text"
							className="cta-button-text"
							label={getMessage('offer.campaigns.config.ctaButtonText')}
							required
							{...generateStateMappers({
								stateKeys: ['ctaButtonText'],
								loseEmphasisOnFill: true,
								validationType: VALIDATION_TYPES.ONSUBMIT,
							})}
						/>
						<Input
							type="text"
							placeholder="Enter CTA Button Link"
							className="cta-button-link"
							label={getMessage('offer.campaigns.config.ctaButtonLink')}
              required
							{...generateStateMappers({
								stateKeys: ['ctaButtonLink'],
								loseEmphasisOnFill: true,
								validationType: VALIDATION_TYPES.ONSUBMIT,
							})}
						/>
					</div>
					<div className="two-col-grid">
						<ColorPicker
							className="cta-button-color"
							label={getMessage('offer.campaigns.config.ctaButtonColor')}
							required
							{...generateStateMappers({
								stateKeys: ['ctaButtonColor'],
								loseEmphasisOnFill: true,
								validationType: VALIDATION_TYPES.ONSUBMIT,
							})}
						/>
						<ColorPicker
							className="cta-button-text-color"
							label={getMessage('offer.campaigns.config.ctaButtonTextColor')}
							required
							{...generateStateMappers({
								stateKeys: ['ctaButtonTextColor'],
								loseEmphasisOnFill: true,
								validationType: VALIDATION_TYPES.ONSUBMIT,
							})}
						/>
					</div>
				</div>

			</div>

			<div className='consolidated-inputs-section'>
					<div className='section-title'>
							Image Uploads
					</div>
					<div className='section-body'>
					<Upload
						className="background-image"
						placeholder="Select Background Image"
						label={getMessage('offer.campaigns.config.backgroundImage')}
						accept={acceptedImgType}
            required
						{...generateStateMappers({
							stateKeys: ['backgroundImage'],
							loseEmphasisOnFill: true,
						})}
					/>
					<Upload
						className="illustration-image"
						placeholder="Select Illustration Image"
						label={getMessage('offer.campaigns.config.illustrationImage')}
						accept={acceptedImgType}
            required
						{...generateStateMappers({
							stateKeys: ['illustrationImage'],
							loseEmphasisOnFill: true,
						})}
					/>
				</div>

			</div>

			<Input
				type="text"
				placeholder="Enter Voucher Wallet Button Text"
				className="voucher-center-title"
				label={getMessage('offer.campaigns.config.voucherWalletButtonText')}
				required
				{...generateStateMappers({
					stateKeys: ['voucherWalletButtonText'],
					loseEmphasisOnFill: true,
					validationType: VALIDATION_TYPES.ONSUBMIT,
				})}
			/>
			<Upload
				className="voucher-wallet-button-icon"
				placeholder="Select Voucher Wallet Button Icon"
				label={getMessage('offer.campaigns.config.voucerhWalletButtonIcon')}
				accept={acceptedImgType}
        required
				{...generateStateMappers({
					stateKeys: ['voucherWalletButtonIcon'],
					loseEmphasisOnFill: true,
				})}
			/>
		</>
	)
}

export default CampaignConfigInputs;
